import { useState, useCallback } from "react";
import { commonPostApi } from "../../utils/apiService.js";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { showToast } from "../../components/common/toast.js";
import { TOAST_TYPE, COMMON_MSG } from "../../constants/toast";

/**
 * Custom hook for managing roles data
 * Handles fetching roles by campaign
 * 
 * @returns {Object} Role details and fetch function
 */
const useRolesData = () => {
  const [roleDetails, setRoleDetails] = useState([]);

  const fetchRolesByCamp = useCallback(async (campId) => {
    if (!campId) return;
    
    try {
      const response = await commonPostApi(API_ENDPOINTS.GET_ALL_ROLES, { 
        camp_details_id: campId 
      });
      const roles = response?.data?.data || [];
      setRoleDetails(roles.map(role => ({
        ...role,
        title: role?.role_name
      })));
    } catch (error) {
      console.error("Error fetching roles:", error);
      showToast(TOAST_TYPE.ERROR, COMMON_MSG.ERROR.GENERIC);
    }
  }, []);

  return { roleDetails, fetchRolesByCamp };
};

export default useRolesData;
